<template>
  <div class="product-col-left">
    <div class="product-img">
      <v-product-tag
        v-if="$store.state.product_tag_list[product_res.ID]"
        :productTag="$store.state.product_tag_list[product_res.ID]"
        :product_res="product_res"
        :productInfo="productInfo"
      ></v-product-tag>
      <v-media-card
        :type="imgData.media_content_type"
        :src="imgData.url"
        :url="imgData.url"
        :thumbnail="imgData.thumbnail"
        :autoplay="true"
        :muted="true"
      />
    </div>
    <ul class="product-img-thumbs row">
      <li
        v-for="(item, index) in gallery"
        :key="'gallery' + item.ID"
        @click="() => selectcommodityimg(index)"
        class="product-img-thumbs-list col-3"
      >
        <div
          class="product-img-thumbs__wrapper"
          :class="{
            'product-img-thumbs__wrapper--active': activeIndex === index,
          }"
        >
          <i
            v-if="item.media_content_type === 'video' || item.media_content_type === 'external_video'"
            class="product-img-thumbs__video-icon"
            :class="{
              'el-icon-video-play': item.media_content_type === 'video',
              'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
            }"
          ></i>
          <v-lazy-img :src="item.thumbnail" :data-url="item.url" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import vProductTag from '@/js/components/view/productTag/productTag.vue'
import mediaCard from '@/js/components/MediaCard.vue'
//import LazyImg from '@/js/components/LazyImg.vue'

export default {
  components: {
    //LazyImg,
    [mediaCard.name]: mediaCard,
    vProductTag,
  },
  props: {
    gallery: {
      type: [Array],
      default: [],
    },
    product_res: {},
    singlecommodity: null,
    productInfo: {},
    is_product: {},
  },
  data() {
    return {
      imgData: {},
      activeIndex: 0,
    }
  },
  beforeMount() {
    this.activeIndex = 0
    this.imgData = this.gallery[0] || {}
  },
  methods: {
    // 选择卡片
    selectcommodityimg(index) {
      if (this.activeIndex === index) return

      this.imgData = this.gallery[index]
      this.activeIndex = index
    },
  },
  watch: {
    '$store.state.feature_image_id'() {
      this.gallery.some((item, index) => {
        if (item.ID == this.$store.state.feature_image_id) {
          this.imgData = item
          this.activeIndex = index
        }
      })
    },
  },
}
</script>

<style lang='scss'>
.product-col-left {
  max-width: 91.66%;
  .product-img {
    position: relative;
    margin-bottom: 30px;
    width: 100%;
    img {
      width: 100%;
    }
  }
  .product-img-thumbs {
    margin: 0 -15px;
    &__wrapper {
      cursor: pointer;
      display: inline-block;
      position: relative;
      // border: 2px solid rgba(0, 0, 0, 0);
      transition: all 0.2s;
      // &--active {
      //   border-color: #000;
      // }
    }
    &__video-icon {
      position: absolute;
      z-index: 2;
      font-size: 24px;
      color: #fff;
      height: 100%;
      width: 100%;
      background: #00000035;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .product-img-thumbs-list {
      margin-bottom: 30px;
      img {
        width: 100%;
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .product-col-left {
    max-width: 100%;
  }
}
</style>
